<template>
  <div v-if="quest">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <template v-if="rebuildInputs && rebuildInputs.length > 0">

      <div
        class="box-outlined mb-5"
      >
        <v-layout
          d-flex
          row
          ma-0
          align-center
          justify-space-between
          class="box-header"
        >
          <v-flex xs12 sm7 lg8>
            <h2
              class="box-header-item mb-3 mb-md-0"
              v-html="quest.info[`title_${$i18n.locale}`]"
            ></h2>
          </v-flex>
          <v-divider vertical inset></v-divider>
          <v-flex xs12 sm3 lg2>
            <p class="box-header-item ma-0 text-center d-flex align-center">
              <span class="h2 mr-1" v-html="quest.done.point"></span>
              <strong>{{ $tc("survey-question-block.point",
                            parseInt(quest.done.point) == 1 ||
                            parseInt(quest.done.point) == 0 ?
                            1 : parseInt(quest.done.point)) }}</strong>
            </p>
          </v-flex>
        </v-layout>

        <div class="box-content pa-0">
          <v-layout
            v-for="input in rebuildInputs"
            :key="input.id"
            class="box-content-item"
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            xs12
            lg10
            :style="{ background: input.bg||input[0].bg }"
          >
            <v-flex
              xs12
              lg10
              offset-lg2
              style="position: relative;"
            >
              <DelegateInputs
                :input="input"
                :collaboratorid="collaboratorid"
                :collaborationkey="collaborationkey"
                :answerid="answerid"
                :path="`${question.path}|${question.id}`"
                @inputUpdated="inputChange"
              ></DelegateInputs>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { delegateQuestion } from '@/js/delegate/delegateQuestion'
import DelegateInputs from '@/components/audits/delegate/DelegateInputs'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    question: Array | Object,
    collaboratorid: String,
    collaborationkey: String,
    answerid: String,
    path: String
  },

  components: {
    DelegateInputs: DelegateInputs,
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      quest: null,
      httpalert: false
    }
  },

  async created () {
    await this.renderQuestion()
  },

  methods: {
    inputChange () {
      this.renderQuestion()
      this.$emit('updateSurveySequenceScore')
    },
    async renderQuestion () {
      const params = {
        collaboratorid: this.collaboratorid,
        collaborationkey: this.collaborationkey,
        questionid: this.question.id
      }
      await delegateQuestion(params)
        .then(response => this.quest = response)
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  },

  computed: {
    rebuildInputs () {
      var inputs = []
      let backgroundColor = '#FFFFFF'
      let padding = false

      this.quest.modules.forEach(async input => {
        const type = input.type

        // check if type is radio or pulldown
        if (type.indexOf('radio') > -1 || type.indexOf('pulldown') > -1) {
          const exist = type in inputs
          if (exist === false) { // if key doesn't exist in table create it then push input
            inputs.push(inputs[type] = [])

            input.bg = backgroundColor
            if (padding) input.padding = padding

            inputs[type].push(input)

            if (input.continued !== 'yes') {
              padding = false
              backgroundColor = backgroundColor === '#FFFFFF' ? 'rgba(243, 244, 249, 0.4)' : '#FFFFFF'
            } else { padding = true }
          } // else if key exist just push in input
          else {
            inputs[type].push(input)
          }
        } else {
          input.bg = backgroundColor
          if (padding) input.padding = padding

          inputs.push(input)

          if (input.continued !== 'yes') {
            padding = false
            backgroundColor = backgroundColor === '#FFFFFF' ? 'rgba(243, 244, 249, 0.4)' : '#FFFFFF'
          } else { padding = true }
        }
      })
      return inputs
    }
  }
}
</script>
